//请自行添加语言资源
const orderModifyLog = {

  schOrderNo:'子订单编号',
  customerCode:'租赁方',
  businessType: '销售板块',
  consigneeCode: '收货方',
  orderCreateTime: '订单创建日期',
  orderUpdateTime:'订单修改日期',
  expectedDeliveryDate:'期望到货日期',
  skuCodes:'SKU',
  consigneeAddrContact:'联系人',
  consigneeAddrTel:'联系方式',
  orderMemo: '备注',
  createTime:'订单创建日期',

  msg:{

  }
};
export default orderModifyLog



// WEBPACK FOOTER //
// ./src/page/report/orderModifyLog/lang/orderModifyLog.zh.js